import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { PeopleEquipmentsTable } from '@/routes/_staff/person/$id/_profile/equipment/-components/EquipmentList';
import { EquipmentSearchSchema } from '@/routes/_staff/person/$id/_profile/equipment/-zod-schema';

const from = '/_staff/person/alumni/$id/_profile/equipment/';

export const Route = createFileRoute(from)({
  component: RouteComponent,
  validateSearch: zodValidator(EquipmentSearchSchema),
});

function RouteComponent() {
  return <PeopleEquipmentsTable from={from} />;
}
